module.exports = __webpack_public_path__ + "static/img/US.5a330cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/US.png
// module id = ZNSm
// module chunks = 2